/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    var isFunction = angular.isFunction;

    export class EmployeePasswordFormDirectiveController {

        public static $inject : string[] = [
            '$scope',
            '$dealerwareNotification',
            '$dealerwareLoading'
        ];

        public employee: any;
        public onSuccess: any;
        public onError: any;

        constructor(public $scope: any,
                    public $dealerwareNotification: any,
                    public $dealerwareLoading: any) {}

        public resetPasswordForm() : void {
            this.employee.accountSettings.data.password = undefined;
            this.employee.accountSettings.data.password_confirmation = undefined;
            this.$scope.passwordForm.$setUntouched();
            this.$scope.passwordForm.$setPristine();
        }

        public savePassword() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.employee.accountSettings.$changePassword({
                promise: true,
                params: { location_id: this.employee.locationId }
            }).then(
                function() {
                    loader.close();
                    if (_self.onSuccess && angular.isFunction(_self.onSuccess)) {
                        _self.onSuccess();
                    } else {
                        _self.$dealerwareNotification.toast('Password saved!');
                        _self.resetPasswordForm();
                    }
                },
                function(response : any) {
                    loader.close();
                    if (_self.onError && angular.isFunction(_self.onError)) {
                        _self.onError({ response: response});
                    } else {
                        _self.$dealerwareNotification.apiError(response);
                    }
                }
            );
        }
    }

    getDealerwareWebComponentsModule().controller('EmployeePasswordFormDirectiveController', EmployeePasswordFormDirectiveController);


    export class EmployeePasswordFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'EmployeePasswordFormDirectiveController';
        public controllerAs     : string    =   'passwordController';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            employee: '=',
            onSuccess: '&?',
            onError: '&?'
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/employee/password/password_form_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   ng.IScope,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareEmployeePasswordForm",() => new EmployeePasswordFormDirective());

}
